import Geocode from 'react-geocode'
import { Coordinates, CoordinatesError, CoordinatesRequestData, ACCEPTED_GOOGLE_RESPONSE_TYPES } from '../types'

/**
 * fetch coordinates for given address data only if usage of google services has been accepted.
 * @param customerFormData address data that the corresponding coordinates are requested for
 * @param googleAgreed boolean whether or not the user agreed to use google maps, because google API is used for the request
 * @returns Promise with latitude and longitude and error flag
 */
export const fetchCoordinates = (
  customerFormData: CoordinatesRequestData | undefined,
  mapsToken: string,
  googleAgreed?: boolean
): Promise<Coordinates> => {
  if (customerFormData && googleAgreed) {
    Geocode.setKey(mapsToken ?? '')
    Geocode.setRegion(customerFormData.countryCode)
    const address = customerFormData.address ?? `${customerFormData.streetName} ${customerFormData.streetNumber}`

    return Geocode.fromAddress(`${address} ${customerFormData.city} ${customerFormData.zip}`).then(response => {
      const isAcceptedResponseType = ACCEPTED_GOOGLE_RESPONSE_TYPES.includes(response.results[0].types[0])

      if (response && response.status === 'OK' && isAcceptedResponseType) {
        const { lat, lng } = response.results[0].geometry.location
        return { latitude: lat.toFixed(10), longitude: lng.toFixed(10) }
      } else {
        return Promise.reject(CoordinatesError.INVALID_RESPONSE)
      }
    })
  }
  return Promise.reject(CoordinatesError.SERVICE_DENIED)
}
